import React, { useEffect } from "react";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import PLANE from "../../../assets/images/plane.png";
import PHONE from "../../../assets/images/phone.png";
import MAIL from "../../../assets/images/mail.png";
import { getBookingDetails } from "../services/mytrips.services";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../../components/spinner/Loading";
import useWindowSize from "../../../_hooks/useWindowSize";
import { calculateFareDetailsFromReprint } from "../../../_helpers/fareUtils";
import { formatIndianNumber } from "../../../_helpers/formatUtils";
import { getFlightImage } from "../../../_helpers/flightUtils";
import { FlightImage } from "../../../components/flightimage/FlightImage";

const CancelConfirmation = () => {
  const dispatch = useAppDispatch();
  const { width } = useWindowSize();
  const loading = useAppSelector((state) => state?.mytrips?.loading);
  const location = useLocation();

  const BookingDetails = useAppSelector(
    (state) => state?.mytrips?.BookinDetails
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const bookingId = params.get("bookingId");

    dispatch(
      getBookingDetails({
        Booking_RefNo: bookingId,
        Airline_PNR: "",
      })
    );
  }, []);

  const faredetails = calculateFareDetailsFromReprint(
    BookingDetails?.AirPNRDetails || []
  );

  return (
    <>
      <Loading loading={loading} backgroundColor="white" />
      {!loading && (
        <div className="Booking-page">
          <div className="container">
            <div className="booking-confirmationbar">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <svg
                    width={55}
                    height={55}
                    viewBox="0 0 55 55"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M34.375 20.625L20.625 34.375M20.625 20.625L34.375 34.375M50.4167 27.5C50.4167 40.1565 40.1565 50.4167 27.5 50.4167C14.8435 50.4167 4.58337 40.1565 4.58337 27.5C4.58337 14.8435 14.8435 4.58337 27.5 4.58337C40.1565 4.58337 50.4167 14.8435 50.4167 27.5Z"
                      stroke="#D93C3C"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <h2 className="text-danger">
                    Your cancellation request was successful!
                  </h2>
                  <p>
                    Your cancellation request has been received. Upon
                    confirmation, any eligible refund will be processed as per
                    our policy.
                  </p>
                  <div className="flight-indcator-id cancelled">
                    <h5>
                      Booking Ref No:{" "}
                      <strong>
                        {BookingDetails && BookingDetails?.portal_booking_no}
                      </strong>
                    </h5>
                    <p>
                      <strong>Booked on: </strong>
                      {BookingDetails &&
                        moment(
                          BookingDetails?.Booking_DateTime,
                          "DD/MM/YYYY HH:mm:ss"
                        ).format("DD/MM/YYYY | hh:mm:ss A")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12">
                <div className="booking-page-right travel-detail-new">
                  <h3>Flight Details</h3>
                  <div className="fligt-confirm">
                    <div className="booking-timing">
                      <div className="booking-flight-half">
                        {BookingDetails?.AirPNRDetails?.map(
                          (tripInfo: any, tripIndex: number) => (
                            <>
                              {tripInfo?.Flights?.map(
                                (flight: any, flightIndex: number) => {
                                  const segments = flight?.Segments || [];

                                  return (
                                    <div
                                      key={tripIndex}
                                      className={`${
                                        tripIndex + 1 <
                                          BookingDetails?.AirPNRDetails
                                            ?.length ||
                                        flightIndex + 1 <
                                          tripInfo?.Flights?.length
                                          ? "flight-review-card"
                                          : ""
                                      }`}
                                    >
                                      <div key={flightIndex}>
                                        <h4>
                                          {segments[0]?.Origin} →{" "}
                                          {
                                            segments[segments.length - 1]
                                              ?.Destination
                                          }
                                        </h4>

                                        {segments.map(
                                          (item: any, index: number) => (
                                            <div
                                              className="booking-timimg-main"
                                              key={index}
                                            >
                                              <h5>Flight {index + 1}</h5>
                                              <div className="route-timing border-0 p-0">
                                                <div className="flight-choose">
                                                  <div className="fight-name">
                                                    <FlightImage
                                                      key={item?.Airline_Code}
                                                      flightCode={
                                                        item?.Airline_Code
                                                      }
                                                    />
                                                    <span>
                                                      <h5>
                                                        {item?.Airline_Name}
                                                      </h5>
                                                    </span>
                                                  </div>
                                                </div>

                                                <div className="route-strating">
                                                  {moment(
                                                    item?.Departure_DateTime
                                                  ).format("HH:mm")}
                                                  <p>
                                                    <strong>
                                                      {item?.Origin}
                                                    </strong>
                                                    {item?.Origin_Terminal
                                                      ? `, Terminal : ${item?.Origin_Terminal}`
                                                      : ""}
                                                  </p>
                                                </div>

                                                <div className="cunsume-time">
                                                  <p>
                                                    Non Stop |{" "}
                                                    <strong>
                                                      {item?.Duration}
                                                    </strong>
                                                  </p>
                                                  <div className="cunsume-pic">
                                                    <img
                                                      src={PLANE}
                                                      alt="plane"
                                                    />
                                                  </div>
                                                  <p>
                                                    {moment(
                                                      item?.Departure_DateTime
                                                    ).format("dddd, DD MMM’YY")}
                                                  </p>
                                                </div>

                                                <div className="route-strating route-arrival">
                                                  {moment(
                                                    item?.Arrival_DateTime
                                                  ).format("HH:mm")}
                                                  <p>
                                                    <strong>
                                                      {item?.Destination}
                                                    </strong>
                                                    {item?.Destination_Terminal
                                                      ? `, Terminal : ${item?.Destination_Terminal}`
                                                      : ""}
                                                  </p>
                                                </div>
                                              </div>

                                              <div className="mobile-timimg">
                                                <div className="cunsume-time">
                                                  <p>
                                                    Non Stop |{" "}
                                                    <strong>
                                                      {item?.Duration}
                                                    </strong>
                                                  </p>
                                                  <p>
                                                    {moment(
                                                      item?.Departure_DateTime
                                                    ).format("dddd, DD MMM’YY")}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="travel-contact">
                    <div className="traveller-list">
                      <h4>Cancelled Traveller</h4>
                      {BookingDetails &&
                        BookingDetails?.AirPNRDetails &&
                        BookingDetails?.AirPNRDetails?.length > 0 &&
                        BookingDetails?.AirPNRDetails?.map(
                          (pnrDetails: any, pnrIndex: number) => (
                            <React.Fragment key={pnrDetails + "-" + pnrIndex}>
                              {pnrDetails?.PAXTicketDetails?.some(
                                (e: any) =>
                                  e?.TicketStatus === "Tocancel" ||
                                  e?.TicketStatus === "Cancelled"
                              ) &&
                                pnrDetails?.Flights?.map(
                                  // TODO if its not working then need to change the logic
                                  (flight: any, flightIndex: number) => {
                                    const segments = flight?.Segments || [];
                                    const origin = segments[0]?.Origin;
                                    const destination =
                                      segments[segments.length - 1]
                                        ?.Destination;

                                    return (
                                      <h5 key={flightIndex}>
                                        {origin} → {destination} -{" "}
                                        {pnrDetails?.Airline_PNR}
                                      </h5>
                                    );
                                  }
                                )}
                              {pnrDetails?.PAXTicketDetails?.map(
                                (traveller: any, index: any) => {
                                  if (
                                    traveller?.TicketStatus === "Tocancel" ||
                                    traveller?.TicketStatus === "Cancelled"
                                  ) {
                                    return (
                                      <div
                                        className="sidebar-content"
                                        key={index}
                                      >
                                        <span>
                                          {`${index + 1}. ${traveller?.Title} ${
                                            traveller?.First_Name
                                          } ${traveller?.Last_Name}`}
                                        </span>
                                        <div className="sidebar-left" />
                                        <div className="sidebar-right">
                                          <span>
                                            {traveller?.Pax_type == 1
                                              ? "CHILD"
                                              : traveller?.Pax_type == 2
                                              ? "INFANT"
                                              : "ADULT"}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  }
                                }
                              )}
                            </React.Fragment>
                          )
                        )}
                    </div>
                    <div
                      className="traveller-contact-detail traveller-list"
                      style={{ height: "fit-content" }}
                    >
                      <h4>Contact Detail</h4>
                      {BookingDetails?.PAX_EmailId && (
                        <Link to={`mailto:${BookingDetails?.PAX_EmailId}`}>
                          <img src={MAIL} alt="e-mail" />
                          {BookingDetails?.PAX_EmailId}
                        </Link>
                      )}
                      {BookingDetails?.PAX_Mobile && (
                        <Link to={`tel:++91 ${BookingDetails?.PAX_Mobile}`}>
                          <img src={PHONE} alt="phone" />
                          {BookingDetails?.PAX_Mobile}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-5 col-sm-12">
                <h3>Fare Details</h3>
                <div
                  className="listing-sidebar booking-sidebar border-0"
                  style={{ top: width <= 991 ? 0 : 100 }}
                >
                  <div className="sidebar-content ">
                    <div className="sidebar-left">
                      <h5>Base Fair</h5>
                    </div>
                    <div className="sidebar-right">
                      <h5>
                        {BookingDetails &&
                          `₹ ${formatIndianNumber(
                            (faredetails?.adults?.basic || 0) +
                              (faredetails?.children?.basic || 0) +
                              (faredetails?.infants?.basic || 0)
                          )}`}
                      </h5>
                    </div>
                  </div>
                  <div className="sidebar-content ">
                    <div className="sidebar-left">
                      <h5>Taxes & Fees</h5>
                    </div>
                    <div className="sidebar-right">
                      <h5>
                        {BookingDetails &&
                          `₹ ${formatIndianNumber(
                            (faredetails?.adults?.taxes || 0) +
                              (faredetails?.children?.taxes || 0) +
                              (faredetails?.infants?.taxes || 0)
                            // (faredetails?.overall?.serviceAmount || 0)
                          )}`}
                      </h5>
                    </div>
                  </div>
                  {BookingDetails?.convenience_fee > 0 && (
                    <div className="sidebar-content pb-1">
                      <div className="sidebar-left">
                        <h5>Convenience Fee</h5>
                      </div>
                      <div className="sidebar-right">
                        <h5>
                          {BookingDetails &&
                            `₹ ${formatIndianNumber(
                              BookingDetails?.convenience_fee
                            )}`}
                        </h5>
                      </div>
                    </div>
                  )}
                  <div
                    className="sidebar-content siderbar-total"
                    style={{
                      borderTop: "1px dashed rgb(0 0 0 / 20%)",
                      padding: "10px 0",
                    }}
                  >
                    <div className="sidebar-left">
                      <h5>
                        <strong>Grand Total</strong>
                      </h5>
                    </div>
                    <div className="sidebar-right">
                      <h5>
                        <strong>
                          {BookingDetails &&
                            `₹ ${formatIndianNumber(
                              (faredetails?.adults?.total || 0) +
                                (faredetails?.children?.total || 0) +
                                (faredetails?.infants?.total || 0) +
                                (BookingDetails?.convenience_fee || 0)
                            )}`}
                        </strong>
                      </h5>
                    </div>
                  </div>
                  {BookingDetails?.PromoCodeValue > 0 && (
                    <div className="sidebar-content pb-2">
                      <div className="sidebar-left">
                        <h5 style={{ color: "#00a34d" }}>
                          PromoCode ({BookingDetails?.PromoCode})
                        </h5>
                      </div>
                      <div className="sidebar-right">
                        <h5 style={{ color: "#00a34d" }}>
                          {BookingDetails &&
                            `- ₹ ${formatIndianNumber(
                              BookingDetails?.PromoCodeValue
                            )}`}
                        </h5>
                      </div>
                    </div>
                  )}
                  {BookingDetails?.GiftCodeValue > 0 && (
                    <div className="sidebar-content pb-2">
                      <div className="sidebar-left">
                        <h5 style={{ color: "#00a34d" }}>
                          GiftCode ({BookingDetails?.GiftCode})
                        </h5>
                      </div>
                      <div className="sidebar-right">
                        <h5 style={{ color: "#00a34d" }}>
                          {BookingDetails &&
                            `- ₹ ${formatIndianNumber(
                              BookingDetails?.GiftCodeValue
                            )}`}
                        </h5>
                      </div>
                    </div>
                  )}
                  {BookingDetails?.wallet_balance > 0 && (
                    <div className="sidebar-content pb-2">
                      <div className="sidebar-left">
                        <h5 style={{ color: "#00a34d" }}>Used Wallet Amount</h5>
                      </div>
                      <div className="sidebar-right">
                        <h5 style={{ color: "#00a34d" }}>
                          {BookingDetails &&
                            `- ₹ ${formatIndianNumber(
                              BookingDetails?.wallet_balance
                            )}`}
                        </h5>
                      </div>
                    </div>
                  )}
                  {BookingDetails?.CreditLimitUsedAmount > 0 && (
                    <div className="sidebar-content pb-0">
                      <div className="sidebar-left">
                        <h5 style={{ color: "#00a34d" }}>Used Credit Limit</h5>
                      </div>
                      <div className="sidebar-right">
                        <h5 style={{ color: "#00a34d" }}>
                          {BookingDetails &&
                            `- ₹ ${formatIndianNumber(
                              BookingDetails?.CreditLimitUsedAmount
                            )}`}
                        </h5>
                      </div>
                    </div>
                  )}
                  <div
                    className="sidebar-content siderbar-total"
                    style={{
                      borderTop: "1px dashed rgb(0 0 0 / 20%)",
                      padding: "10px 0",
                    }}
                  >
                    <div className="sidebar-left">
                      <h5>
                        <strong>Total Paid</strong>
                      </h5>
                    </div>
                    <div className="sidebar-right">
                      <h5>
                        <strong>
                          {BookingDetails &&
                            `₹ ${formatIndianNumber(
                              (faredetails?.adults?.total || 0) +
                                (faredetails?.children?.total || 0) +
                                (faredetails?.infants?.total || 0) +
                                (BookingDetails?.convenience_fee || 0) -
                                (BookingDetails?.PromoCodeValue || 0) -
                                (BookingDetails?.GiftCodeValue || 0) -
                                (BookingDetails?.wallet_balance || 0) -
                                (BookingDetails?.CreditLimitUsedAmount || 0)
                            )}`}
                        </strong>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CancelConfirmation;
